<template>
  <div class="prednosti_wrapper">
    <div class="prednosti_title">
      Naše usluge:
    </div>
      <div class="boxes">
        <div class="box">
          <prismic-image :field="box_image" class="box_image"/>
          <prismic-image :field="box1_icon" class="box_icon"/>
          <div class="box_title">{{ $prismic.richTextAsPlain(box1_title) }}</div>
        </div>
        <!-- end box -->
        <div class="box">
          <prismic-image :field="box_image" class="box_image"/>
          <prismic-image :field="box2_icon" class="box_icon"/>
          <div class="box_title">{{ $prismic.richTextAsPlain(box2_title) }}</div>
        </div>
        <!-- end box -->
        <div class="box">
          <prismic-image :field="box_image" class="box_image"/>
          <prismic-image :field="box3_icon" class="box_icon"/>
          <div class="box_title">{{ $prismic.richTextAsPlain(box3_title) }}</div>
        </div>
        <!-- end box -->
      </div>
      <!-- end boxes -->
  </div> <!-- prednosti wrapper -->
</template>

<script>
export default {
  name: 'Prednosti',
  data () {
    return {

      box_image:null,
      box1_title:null,
      box1_icon:null,
      box2_title:null,
      box2_icon:null,
      box3_title:null,
      box3_icon:null,
    }
  },
  methods: {

    getContent () {
      //homepage general data
      this.$prismic.client.getSingle('homepage')
        .then((document) => {
          if (document) {
            this.box_image = document.data.box_image
            this.box1_title = document.data.box1_title
            this.box1_icon = document.data.box1_icon
            this.box2_title = document.data.box2_title
            this.box2_icon = document.data.box2_icon
            this.box3_title = document.data.box3_title
            this.box3_icon = document.data.box3_icon


          } else {
            this.$router.push({ name: 'not-found' })
          }
        })
    }  

  },

  mounted () {
    this.getContent(); 
  } 

}
</script>